import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import React from "react";
import { LanguageContext } from "../../../containers/languageprovider";

const ConfirmationMessagePopUp = ({
  openConfirmationMessagePopUp,
  hideConfirmationMessagePopUp,
  confirmStarUnitHandler,
}) => {
  const { dictionary } = React.useContext(LanguageContext);

  return (
    <Dialog
      open={openConfirmationMessagePopUp}
      onClose={hideConfirmationMessagePopUp}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="sm"
      style={{ padding: "0 1rem" }}
    >
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ textAlign: "center", color: "#000000", fontSize: "15px" }}
        >
          {dictionary.ConfirmMatchUnit}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ marginBottom: "0.5rem" }}>
        <Button
          color="primary"
          autoFocus
          style={{ marginRight: "0.5rem", fontSize: "15px" }}
          onClick={confirmStarUnitHandler}
        >
          OK
        </Button>
        <Button
          style={{ color: "gray", fontSize: "15px" }}
          onClick={hideConfirmationMessagePopUp}
        >
          {dictionary.cancelTooltip}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationMessagePopUp;
